"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
require("typeface-roboto");
require("typeface-roboto-mono");
const CssBaseline_1 = tslib_1.__importDefault(require("@mui/material/CssBaseline"));
const CssBaseline = (props) => react_1.default.createElement(CssBaseline_1.default, { ...props });
exports.default = CssBaseline;
